import { Outlet } from 'react-router-dom'
import Navigation from './Navigation'
import Footer from './Footer'

/** Standard chrome (nav + footer) shared by every non-home page. */
export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#f4f7f2]">
      <Navigation />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
